import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { reduxForm } from 'redux-form'
import { Grid, Button } from '@material-ui/core'
import { FORM_HUELLA } from '../../../config/forms'
import logoKeySession from '../../../logo/key-kession-icon.png'

class SessionDialog extends Component {
  render () {
    return (
      <Grid container direction='column' spacing={2} alignItems='center'>
        <h4>Tu sesión ha finalizado.</h4>
        <hr />
        <img src={logoKeySession} style={{ height: '150px' }} alt='keysession' />
        <hr />
        <h6>Por favor vuelve a iniciar sesión</h6>
        <hr />
        <Button variant='contained' color='primary'
          onClick={() => {
            this.props.closeDialogSession()
          }}
        >
          Cerrar
        </Button>
      </Grid>
    )
  }
}

const mapStateToProps = state => {
  return {

  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_HUELLA,
  enableReinitialize: true
})(SessionDialog))
